import React,{useState} from 'react';
import {ComponentWrapper, UserNameLabel, OpinionTextArea, Button, OpinionAreaWrapper} from './styles/TextboxComponent-style';


function TextboxComponent(props) {
    const [userInput, setUserInput] = useState('');
    const [localopinions, setlocalopinions] = useState([]);

  
    function handleSubmit(){
      //function to call main component handler to update the user opinion in updateopiniondict
      // Function clears the text box after user input
      setlocalopinions(prevState => [...prevState, 
        {userInput: userInput}
      ]);
      props.updateopiniondict(props.item.name, userInput);
      setUserInput('');
    }
  
    
    
    return (
      <ComponentWrapper className='userpointers' key={props.item.id}>
        <UserNameLabel>
          {props.item.name}
        </UserNameLabel><hr></hr>
        <OpinionTextArea  
          value={userInput}
          placeholder='Enter Opinion Here'
          onChange={e => setUserInput(e.target.value)}
          /><hr></hr>
        <Button type='Submit' onClick={handleSubmit}>Submit</Button>
        <OpinionAreaWrapper>
          <ul>
          {localopinions.map(localopinions => (
            <li>{localopinions.userInput}</li>
          ))}
          </ul>
        </OpinionAreaWrapper>
      </ComponentWrapper>
    );
  }

  export default TextboxComponent